import apiService from '@/api/apiService';

export const finishVersion = async (balanceId, requiresBooking) => {
    const url = `/api/admin/balance/version/finish/${balanceId}`;
    const data = {
        requires_booking: requiresBooking
    };

    return apiService.PUT(url, data);
};

export const saveVersionWorkspace = async (balanceId, payload) =>
    apiService.PUT(`/api/admin/balance/version/workspace/${balanceId}`, payload);
